export default "__VITE_ASSET__oqTAM8mQ__"